import { useCheckPermission } from 'hooks/useCheckPermission';
import { useIsFeatureEnabled } from 'hooks/useIsFeatureEnabled';
import AllELCDetail from 'pages/private/ELCs/ELCDetail/AllELCDetail';
import AllELCs from 'pages/private/ELCs/ELCList/AllELCs';
import ELCPillarsOfStrength from 'pages/private/ELCs/ELCDetail/ELCPillarsOfStrength';
import ActionPlan from 'pages/private/ELCs/ActionPlan/ActionPlan';
import AllElcsActionPlan from 'pages/private/ELCs/ActionPlan/AllElcsActionPlan';
import { RoutesPaths, SubRouteType } from 'routes/Routes.types';

const useGetELCsSubRoutesData = () => {
  const isPillarsManagementEnabled = useIsFeatureEnabled('pillars_management');

  const ELCsSubRoutes: SubRouteType[] = [
    {
      component: AllELCs,
      path: RoutesPaths.ELCS,
      show: false,
      showByPermissions: useCheckPermission('ELC_LIST_VIEW'),
    },
    {
      component: AllElcsActionPlan,
      path: RoutesPaths.ALL_ELCS_ACTION_PLAN,
      show: false,
      showByPermissions:
        useCheckPermission('PILLARS_VIEW') && isPillarsManagementEnabled,
    },
    {
      component: AllELCDetail,
      path: RoutesPaths.ELC_DETAIL,
      show: false,
      showByPermissions: useCheckPermission('ELC_LIST_VIEW'),
    },
    {
      component: AllELCDetail,
      path: RoutesPaths.ELC_DETAIL_INPUTS_OUTPUTS,
      show: false,
      showByPermissions: useCheckPermission('ELC_LIST_VIEW'),
    },
    {
      component: ELCPillarsOfStrength,
      path: RoutesPaths.ELC_PILLARS_OF_STRENGTH,
      show: false,
      showByPermissions: useCheckPermission('PILLARS_VIEW'),
    },
    {
      component: ActionPlan,
      path: RoutesPaths.ELC_ACTION_PLAN,
      show: false,
      showByPermissions:
        useCheckPermission('ELC_LIST_VIEW') && isPillarsManagementEnabled,
    },
  ];
  return { ELCsSubRoutes };
};

export default useGetELCsSubRoutesData;
